import { useMemo } from "react";
import useAuth from "app/hooks/useAuth";
import {
  resolveOperationalAccess,
  buildWorkspaceReduction,
  UI_SHELL,
} from "@hms-operational";

export default function useOperationalAccess() {
  const { user } = useAuth();

  return useMemo(() => {
    const access = resolveOperationalAccess({
      permissions: user?.permissionList ?? [],
      uriList: user?.uriList ?? [],
      menuItems: user?.menuItemList ?? [],
      accessControlList: user?.accessControlList ?? [],
      operationalModules: user?.operationalModules ?? null,
      appsCode: user?.appsCode ?? null,
      shell: UI_SHELL.HEALTHCARE_UI,
    });
    const reduction = buildWorkspaceReduction(access);
    return {
      access,
      reduction,
      canAccessModule: (moduleId) => access.canAccessModule(moduleId),
      canAccessMasterModule: (moduleId) => access.canAccessMasterModule?.(moduleId),
      hasActionPermission: (keyOrKeys) => access.hasActionPermission?.(keyOrKeys),
      hasExplicitActionPermission: (keyOrKeys) => access.hasExplicitActionPermission?.(keyOrKeys),
      canAccessPath: (pathname) => access.canAccessPath(pathname),
    };
  }, [user]);
}
